import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';

class Page_Login extends Component {

    constructor() {
        super();
        this.state = {
            tb_Login_Value: null,
            tb_PW_Value: '',
        }
    }

    async click_CheckAuthentication() {
        console.log('login = ' + this.state.tb_Login_Value);
        console.log('password = ' + this.state.tb_PW_Value);
        window.location.assign("/Page_Register");

    }


    render() {

        return (
            <div >
                <h1>Page Login</h1>
                <InputText value={this.state.tb_Login_Value} onChange={(e) => this.setState({ tb_Login_Value: e.target.value })} />

                <Password value={this.state.tb_PW_Value} onChange={(e) => this.setState({ tb_PW_Value: e.target.value })} />

                <Button label="Login" onClick={() => { this.click_CheckAuthentication() }} />

                <Link to='/Page_Register'>
                    <li >Register</li>
                </Link>
            </div >
        );
    }
}

export default Page_Login;
